
const menuToggle = () =>{
  const boton = document.getElementById('btnPanel')
  const panel = document.getElementById('panel')
  const icono = document.getElementById('toggle-menu')

  boton.addEventListener('click', () =>{
    panel.classList.toggle('Panel-activo')
    icono.classList.toggle('panel-is-open')
  })
}

export {
  menuToggle
}
